<!-- 新闻列表 -->
<template>
  <div
    class="component-news-list"
    :class="{
      componentnewslistmobile: isphone,
      componentnewslistpc: isphone == false
    }"
  >
    <div class="all-content">
      <div class="title">
        <div class="bigtitle">
          <span class="titlestyle">祭奠英烈·</span>精神传承
        </div>
        <div class="more">
          <router-link
            :to="{ path: '/newslist', query: { type: jsccnum } }"
            class="slide-item-content"
            target="_blank"
          >
            更多>>
          </router-link>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li
            @click="num = 1"
            class="tabnoactive def-hover-trs"
            :class="{ tabactive: num === 1 }"
          >
            各地公祭活动
          </li>
          <li
            @click="num = 2"
            class="tabnoactive def-hover-trs"
            :class="{ tabactive: num === 2 }"
          >
            为烈属办实事
          </li>
        </ul>
      </div>
      <div class="list">
        <!-- <span class="centerline">123</span> -->
        <ul v-show="num === 1">
          <li v-for="(item, index) in gdgjhd" :key="index">
            <div class="img">
              <a
                :href="
                  'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                    item.basicId
                "
                target="_blank"
              >
                <img :src="item.basicThumbnail" />
              </a>
            </div>
            <div class="cont">
              <div
                class="conttitle titlehang1 def-hover-trs"
                @click="infocontent(item.basicId)"
              >
                {{ item.basicTitle }}
              </div>
              <div
                class="content  def-hover-trs"
                :class="{
                  contenthangmobile: isphone,
                  contenthang: isphone == false
                }"
                @click="infocontent(item.basicId)"
              >
                {{ item.basicRoundup }}
              </div>
            </div>
          </li>
        </ul>

        <ul v-show="num === 2">
          <li v-for="(item, index) in wlsbss" :key="index">
            <div class="img">
              <a
                :href="
                  'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                    item.basicId
                "
                target="_blank"
              >
                <img :src="item.basicThumbnail" />
              </a>
            </div>
            <div class="cont">
              <div
                class="conttitle titlehang1 def-hover-trs"
                @click="infocontent(item.basicId)"
              >
                {{ item.basicTitle }}
              </div>
              <div
                class="content  def-hover-trs"
                :class="{
                  contenthangmobile: isphone,
                  contenthang: isphone == false
                }"
                @click="infocontent(item.basicId)"
              >
                {{ item.basicRoundup }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentNewsList",
  filters: {
    htmlfilter: function(val) {
      return val.replace(/<[^>]*>/g);
    }
  },
  data() {
    return {
      isphone: false,
      num: 1
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  props: ["gdgjhd", "wlsbss", "jsccnum"],
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    infocontent(id) {
      window.open(
        "http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=" + id
      );
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.slide-item-content {
  color: #000;
}
.slide-item-content:hover {
  color: var(--main-color);
}
li {
  list-style: none;
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  /* height: 760px; */
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  margin-top: 12px;
}
.all-content {
  width: 1140px;
  /* height: 725px; */
  padding-bottom: 60px;
  position: relative;
  margin: 0 auto;
  top: 10px;
}
.title,
.tab,
.list {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.title {
  line-height: 15px;
}
.list {
  /* height: 600px; */
  top: 50px;
}
.centerline {
  height: 600px;
  width: 10px;
  background-color: var(--main-color);
}
.list ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.list ul li {
  width: 567px;
  height: 174px;
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.img {
  width: 247px;
  height: 173px;
}

.img img {
  width: 100%;
  height: 100%;
  transition: all 0.4s;
}
.img img:hover {
  transform: scale(1.02);
}
.cont {
  position: relative;
  right: 16px;
}
.cont .conttitle {
  width: 281px;
  font-size: 16px;
  position: relative;
  /* top: 10px; */
  color: #000;
}
.cont .conttitle a {
  color: #000;
}
.cont .conttitle a:hover {
  color: var(--main-color);
}
.cont .content {
  width: 281px;
  position: relative;
  top: 10px;
  font-size: 14px;
  color: #545454;
}
.cont .conttitle:hover {
  color: var(--main-color);
  cursor: pointer;
}
.cont .content:hover {
  color: var(--main-color);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/chuancheng.vue